import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { BkUiActionsModule } from "../actions/actions.module";
import { CardComponent } from "./card.component";

@NgModule({
  declarations: [CardComponent],
  imports: [
    CommonModule,
    BkUiActionsModule
  ],
  exports: [CardComponent],
})
export class BkUiCardModule { }
